import { render, staticRenderFns } from "./InventoryPricingHistoryComponent.vue?vue&type=template&id=1735c712&scoped=true"
import script from "./InventoryPricingHistoryComponent.vue?vue&type=script&lang=js"
export * from "./InventoryPricingHistoryComponent.vue?vue&type=script&lang=js"
import "./InventoryPricingHistoryComponent.vue?vue&type=style&index=0&id=1735c712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735c712",
  null
  
)

export default component.exports